<template>
  <section class="main-section" >
    <div class="title" data-reveal-text :class="{ 'title-mob': !isPC }">
      <!-- <div class="left-line"></div> -->
      <div class="main-title" v-if="isPC">极简格调，先锋气场</div>
      <div class="main-title-mb" v-else>极简格调<br/>先锋气场</div>
    </div>
    <div class="gediao" :class="{ 'gediao-mob': !isPC }" ref="section3">
      <!-- <div v-if="isPC" style="width: 100%;height: 100%;">
        <video class="custom-video" autoplay preload="auto" loop webkit-playsinline="true"
          playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" muted
          style="object-fit:cover;width: 100%;height: 100%;">
          <source src="https://img.kia.cn/content/videos/20240126/carSize.mp4">
        </video>
      </div> -->
      <div class="desc-main" :class="{ 'desc-main-mob': !isPC }">
        <!-- <countTo v-if="startAnimation" :start-val="0" :end-val="100" /> -->
        <div ref="targetElement">
          <div class="about-number" v-if="isPC">
            <div class="number" ref="number">
              <div class="animate-title">
                车长
              </div>
              <div class="animate-number">
                <!-- <span>4,615</span> -->
                <countTo :startVal="startVal" :endVal="endVal" :duration="5000"></countTo>
                <span>mm</span>
              </div>
            </div>
            <div class="number" ref="number1">
              <div class="animate-title">
                车宽
              </div>
              <div class="animate-number">
                <!-- <span>1,875</span> -->
                <countTo :startVal="startVal1" :endVal="endVal1" :duration="5000"></countTo>
                <span>mm</span>
              </div>
            </div>
            <div class="number" ref="number2">
              <div class="animate-title">
                车高
              </div>
              <div class="animate-number">
                <!-- <span>1,715</span> -->
                <countTo :startVal="startVal2" :endVal="endVal2" :duration="5000"></countTo>
                <span>mm</span>
              </div>
            </div>
            <div class="number" ref="number3">
              <div class="animate-title">
                轴距
              </div>
              <div class="animate-number">
                <!-- <span>2,750</span> -->
                <countTo :startVal="startVal3" :endVal="endVal3" :duration="5000"></countTo>
                <span>mm</span>
              </div>
            </div>
          </div>
          <div class="about-number" :class="{ 'about-number-mob': !isPC }" v-else>
            <div class="two-element">
              <div class="number" ref="number">
                <div class="animate-title">
                  车长
                </div>
                <div class="animate-number">
                  <!-- <span>4,615</span> -->
                  <countTo :startVal="startVal" :endVal="endVal" :duration="5000"></countTo>
                  <span>mm</span>
                </div>
              </div>
              <div class="number" ref="number1">
                <div class="animate-title">
                  车宽
                </div>
                <div class="animate-number">
                  <!-- <span>1,875</span> -->
                  <countTo :startVal="startVal1" :endVal="endVal1" :duration="5000"></countTo>
                  <span>mm</span>
                </div>
              </div>
            </div>
            <div class="two-element">
              <div class="number" ref="number2">
                <div class="animate-title">
                  车高
                </div>
                <div class="animate-number">
                  <countTo :startVal="startVal2" :endVal="endVal2" :duration="5000"></countTo>
                  <!-- <span>1,715</span> -->
                  <span>mm</span>
                </div>
              </div>
              <div class="number" ref="number3">
                <div class="animate-title">
                  轴距
                </div>
                <div class="animate-number">
                  <!-- <span>2,750</span> -->
                  <countTo :startVal="startVal3" :endVal="endVal3" :duration="5000"></countTo>
                  <span>mm</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import countTo from 'vue-count-to'
import { isPortraitFun, getUrlKey, isPc } from "@/utils/utils.js";
export default {
  data() {
    return {
      startVal: 0,
      endVal: 4615,
      startVal1: 0,
      endVal1: 1875,
      startVal2: 0,
      endVal2: 1715,
      startVal3: 0,
      endVal3: 2750,
      showCounter: false,
      startAnimation: false,
      isPC:isPc(),
      played: false,
    }
  },
  components: { countTo },
  mounted() {
    const element = document.querySelector(".desc-main");
    let that = this
    window.addEventListener('scroll', function () {
      // 获取元素的位置信息
      const rect = element.getBoundingClientRect();
      if (!that.played && rect.top >= 0 && rect.bottom <= window.innerHeight) {
        that.played = true
        that.showActive()
      }else if(rect.top < 0 || rect.bottom > window.innerHeight){
        that.played=false
      }
    });
    gsap.registerPlugin(ScrollTrigger)
    //window.addEventListener('scroll', this.handleScroll1, true)//滚动监听
    window.addEventListener('message', function (event) {
      if (
        event.origin === 'https://uat.kia.cn' &&
        event.data === 'invokeMethod'
      ) {
        // Call the Vue method inside the iframe
        console.log(this)
        //that.showActive()
      }
    })
    // window.addEventListener('message', function (event) {
    //   if (
    //     event.origin === 'https://uat.kia.cn' &&
    //     event.data === 'invokeMethod'
    //   ) {
    //     var domNode = document.querySelector('[ref="section3"]')
    //     var isInViewport = that.isNodeInViewport(domNode)

    //     // Send the result back to the parent window
    //     window.parent.postMessage(isInViewport, '*');
    //     if (isInViewport) {
    //       that.showActive()
    //     }
    //   }
    // })
  },
  methods: {
    isNodeInViewport(node) {
      var rect = node.getBoundingClientRect()
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= window.innerHeight &&
        rect.right <= window.innerWidth
      )
    },
    handleScroll1() {
      const element = this.$refs.targetElement
      const rect = element.getBoundingClientRect()
      console.log(rect, '111')
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      console.log(window.innerHeight)
      console.log(scrollTop)
      if (rect.top + 0.2 * window.innerHeight < window.innerHeight) {
        this.showActive()
        //this.startAnimation = true;
      }
    },
    handleScroll() {
      // 实现当滚动到指定位置，触发动画
      // let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
      // this.gdjz('earth', 'earth animated bounceInDown', 50)
      let _this = this
      let refArray = [{ ref: 'section3' }]
      refArray.forEach((r, i) => {
        _this.gdjz(
          r.ref,
          400,
          () => {
            _this.showActive()
          },
          () => {
            _this.showUnActive()
          },
        )
      })
    },
    gdjz(div, offset, callback, callback1) {
      let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
      if (dom) {
        var a, b, c, d
        d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
        a = eval(d + offset)
        b =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop //  获取窗口滚动条高度
        c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
        console.log(b, 'bbb')
        console.log(c, 'ccccc')
        console.log(a, 'aaaaa')
        if (b + c > a) {
          callback && callback()
        } else {
          callback1 && callback1()
        }
      }
    },
    showActive() {
      this.startVal == 0 ? this.startVal = 1 : this.startVal = 0
      this.startVal1 == 0 ? this.startVal1 = 1 : this.startVal1 = 0
      this.startVal2 == 0 ? this.startVal2 = 1 : this.startVal2 = 0
      this.startVal3 == 0 ? this.startVal3 = 1 : this.startVal3 = 0
    },
    showUnActive() {
      this.endVal = 4615
      this.endVal1 = 1875
      this.endVal2 = 1715
      this.endVal3 = 2750
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  position: absolute;
  left: calc(160 / 1920 * 100vw);
  top: calc(200 / 1080 * 100vh);
  display: flex;
  z-index: 99;
  // padding: calc(156/1920*100vw) 0 calc(86/1920*100vw) calc(160/1920*100vw);
  .left-line {
    width: calc(4/1920*100vw);
    height: calc(42/1920*100vw);
    background: #3a88bc;
    opacity: 1;
    margin-right: calc(50/1920*100vw)
  }
  .main-title {
    font-family: 'chuhei';
    font-size: 2.083333vw;
    line-height: 2.1875vw;
    color: #fff;
  }
  .main-title-mb{
    color:#000;
    font-size: calc(32 / 375 * 100vw);
    font-weight: 400;
  }
  &-mob {
    position: absolute;
    margin:0;
    padding-left:0;
    top: calc(150 / 750 * 100vw);
    left: calc(50 / 750 * 100vw);
    z-index: 2;
    padding-top:0;
    .main-title {
      font-size: calc(48 / 750 * 100vw);
      line-height: calc(49 / 750 * 100vw);
      color: #fff;
    }

    .left-line {
      width: calc(5 / 750 * 100vw);
      height: calc(49 / 750 * 100vw);
      margin-right: calc(35 / 750 * 100vw);
    }
  }
}
.animate-title {
  font-size: calc(20/1920*100vw);
  color: #000;
  margin-bottom:calc(20/1920*100vw);
}
.number {
  display: flex;
  // align-items: center;
  flex-direction: column;
  color: #000;
  padding:0 calc(80/1920*100vw);
  // border-right:1px solid #000;
}
.number:nth-last-child(1){
  border-right:0;
}
.animate-number {
  font-size: calc(32/1920*100vw);
  // border-bottom: 4px solid #000;
  font-family: 'KiaSignatureBold';
  display: flex;
  justify-content: center;
  // margin: 0 calc(80/1920*100vw);
}
.desc-main {
  position: absolute;
  // bottom: calc(116 / 1080 * 100vh);
  bottom: calc(300 / 1080 * 100vh);
  left: 50%;
  transform: translateX(-50%);

  &-mob {
    bottom: calc(175 / 1624 * 100vh);
  }

  .about-number {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    &-mob{
      width:calc(510/750*100vw);
      flex-wrap: wrap;
      .two-element{
        width:100%;
        display:flex;
        justify-content: space-between;
        align-items: center;
        .number{
          border-right:0;
          padding:0;
        }
      }
      .two-element:nth-of-type(1){
        margin-bottom:calc(100/750*100vw);
      }
      .animate-title{
        font-size:calc(24/750*100vw);
        margin-bottom:calc(26/750*100vw);
      }
      .animate-number {
        font-size: calc(40/750*100vw);
        border-bottom: calc(4/750*100vw) solid #000;
        font-family: 'KiaSignatureBold';
      }
    }
  }
}

.main-section {
  width: 100vw;
  margin: 0 auto;
}

.gediao {
  width: 100vw;
  margin: 0 auto;
  position: relative;
  height: 56.25vw;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/animatenumber/bg.png');
  background-size: 100% auto;
  background-position: bottom;
}

.gediao-mob {
  width: 100vw;
  height: calc(812/375*100vw);
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/animatenumber/bgmob.png');
  background-size: 100% auto;
}
.mobile-line{
  width:1PX;
  height:calc(66/750*100vw);
  background: #000;
}
</style>
